module.exports = __webpack_public_path__ + "img/verifiedStatusB.c3995009.svg";